import { RichText as RichTextString } from "./RichText";
import { DisclosureList } from "./DisclosureList";
import { Fragment } from "react";

interface FAQListProps {
  faqs?: { question: string; answer: React.ReactNode }[];
}

export function FAQList({ faqs }: FAQListProps) {
  if (!faqs) {
    return null;
  }

  return (
    <DisclosureList
      items={faqs.map((faq, faqIndex) => ({
        title: faq.question || "",
        body: (
          <Fragment key={faqIndex}>
            <div className='tw-whitespace-pre-wrap'>
              {/* This may look strange but it is correct. RichTextString handles html strings if answer is not a string its a server component needs to be rendered as is */}
              {typeof faq.answer === "string" ? <RichTextString content={faq.answer} color='gray' /> : faq.answer}
            </div>
          </Fragment>
        ),
      }))}
    />
  );
}
